<template>
  <el-dialog :title="title"
             :width="width"
             :visible.sync="showSingleDialog"
             :close-on-click-modal="false"
             :modal="showModal"
             @open="onOpen"
             @close="onClose">
    <div>
      <slot></slot>
    </div>
    <span v-if="showFooter"
          slot="footer"
          class="dialog-footer">
      <slot name="buttons">
        <el-button type="primary"
                   @click="confirm">{{$t('system.common.button.confirm')}}</el-button>
        <el-button type="info"
                   @click="close">{{$t('system.common.button.cancel')}}</el-button>
      </slot>
    </span>
  </el-dialog>
</template>
<script>
/**
 * 对话框组件
 */
export default {
  name: 'EduDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '50%'
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showModal: {
      default: true
    }
  },
  data() {
    return {
      showSingleDialog: false
    }
  },
  methods: {
    open() {
      this.showSingleDialog = true
    },
    onOpen() {
      setTimeout(() => {
        this.$emit('open')
      }, 300)
    },
    close() {
      this.showSingleDialog = false
    },
    onClose() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>
